import { useAuth0 } from "@auth0/auth0-react"
import { Button } from "@mui/material"
import { useTranslation } from "react-i18next"

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0()
  const { t } = useTranslation()
  return (
    <Button
      variant="contained"
      onClick={() => loginWithRedirect()}
      sx={{
        textTransform: "none",
        width: "200px",
        // backgroundColor: "primary.main",
      }}
    >
      {t("login")}
    </Button>
  )
}

export default LoginButton
